module.exports = __webpack_public_path__ + "img/tw.d6425bb2.svg";